import { render, staticRenderFns } from "./ProjectTeamAdd.vue?vue&type=template&id=1fd0de44&scoped=true"
import script from "./ProjectTeamAdd.vue?vue&type=script&lang=js"
export * from "./ProjectTeamAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd0de44",
  null
  
)

export default component.exports